import React, { useEffect, useState } from "react";
import { Button, Dropdown, DropdownItemProps, Form, Grid, Icon, Label } from "semantic-ui-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useField } from "formik";
import MyHelpButton from "./MyHelpButton";
import { useStore } from "../../stores/store";
import { TicketItemFormValues } from "../../models/ticket";
import { PartInventoryFormValues } from "../../models/inventory";
import AddVendor from "../../../features/vendor/AddVendor";
import { useTranslation } from "react-i18next";
import { SettingsVendorsFormValues, VendorsFormValues } from "../../models/vendor";

interface Props {
    placeholder: string;
    name: string;
    options: DropdownItemProps[];
    label?: string;
    className?: string;
    showHelp?: boolean;
    helpName?: string;
    onChange?: (value: any) => void;
    showDefaults?: boolean;
    onSetDefaults?: (value: string) => void;
    clearable?: boolean;
    value?: string;
    part?: TicketItemFormValues | PartInventoryFormValues;
    hideAdd?: boolean;
    onCloseModal?: (v?: VendorsFormValues) => void;
    disabled?: boolean;
}
const InventoryStockVendorSelect = ({
    placeholder,
    name,
    options,
    label,
    className,
    showHelp,
    helpName,
    onChange,
    clearable,
    part,
    value,
    hideAdd,
    onCloseModal,
    disabled,
}: Readonly<Props>) => {

    const [inputValue, setInputValue] = useState<string>("");
    const [field, meta, helpers] = useField(name);
    const { modalStore, ticketStore } = useStore();
    const { t } = useTranslation(["common", "miscSettings"]);

    const {
        loadSettingsTicketInputDefaults,
        selectedSettingsTicketInputDefaults,
    } = ticketStore;

    useEffect(() => {
        loadSettingsTicketInputDefaults();
    }, [loadSettingsTicketInputDefaults]);

    const settingsVendor = new SettingsVendorsFormValues();

    return (
        <Form.Field error={meta.touched && !!meta.error}>
            {label && (
                <label htmlFor="autocomplete" className={`${className ?? ""} myLabel`}>
                    {`${label} `}
                    {showHelp && (
                        <MyHelpButton
                            name={`${name}.help`}
                            help={helpName ?? ""}
                            color={"blue"}
                        />
                    )}
                </label>
            )}
            <Grid.Row columns={2}>
                <Grid.Column className={hideAdd ? "w100 noPaddingRight" : "w75 noPaddingRight"}>
                    <Dropdown
                        id="autocomplete"
                        placeholder={placeholder ?? ""}
                        fluid
                        search
                        selection
                        options={options}
                        value={value ? value : field.value ?? ""}
                        onBlur={() => helpers.setTouched(true)}
                        disabled={disabled}
                        onChange={(e, d) => {
                            helpers.setValue(d.value);
                            setInputValue("");
                            onChange?.(d.value);
                        }}
                        onSearchChange={(e, data) => setInputValue(data.searchQuery)}
                        onKeyDown={(e: React.KeyboardEvent) => {
                            if (e.key === "Enter" && inputValue.trim()) {
                                // Add input value as a new option and select it
                                helpers.setValue(inputValue.trim());
                                setInputValue(""); // Clear input after adding
                            }
                        }}
                        style={{ width: "100%" }}
                        clearable={clearable ?? false}
                    />
                </Grid.Column>
                {!hideAdd && !disabled && (
                    <Grid.Column className="w25 noPadding">
                        <Button color="blue" className="w75 h100 d-flex justify-content-center align-items-center" type="button"
                            onClick={() =>
                                modalStore.openModal(<AddVendor 
                                    name={""}
                                    header={t("vendors.add_vendor", { ns: "miscSettings" })}
                                    isAdd={true}
                                    defaults={settingsVendor}
                                    autoCapitalizeFirstLetter={
                                        selectedSettingsTicketInputDefaults.capitalizeFirstCharacter
                                    }
                                    onCloseModal={onCloseModal}
                                />)
                            }>
                            <Icon name="plus" className="m0" />
                        </Button>
                    </Grid.Column>

                )}
            </Grid.Row>
            {meta.touched && meta.error && (
                <Label basic color="red">
                    {meta.error}
                </Label>
            )}
        </Form.Field>
    );
};

export default InventoryStockVendorSelect;
